import { Helmet } from "react-helmet";
import { useTranslationApp } from "../../lib/i18next";

const AuthPageHelmet = ({ documentTitleKey, nameBusiness }) => {
  const { t } = useTranslationApp();

  return (
    <Helmet>
      <title>{t(documentTitleKey, { nameBusiness })}</title>
    </Helmet>
  );
};

export default AuthPageHelmet;
